import { Card } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { inr, num } from "@/lib/api";
import { Package } from "lucide-react";

const ICONS = {
  cement: "🧱",
};

export const MaterialBreakdown = ({ result }) => {
  if (!result) return null;
  return (
    <Card className="bg-slate-900/70 border-slate-800 rounded-2xl p-6 sm:p-8" data-testid="material-breakdown">
      <div className="flex items-center gap-3 mb-6">
        <div className="h-10 w-10 rounded-xl bg-amber-500/15 grid place-items-center">
          <Package className="h-5 w-5 text-amber-400" />
        </div>
        <div>
          <h3 className="font-heading text-xl font-bold text-white">Material Quantities</h3>
          <p className="text-sm text-slate-400">
            Estimated for {inr(result.inputs.total_area)} sq.ft · {result.inputs.quality} quality
          </p>
        </div>
      </div>

      <div className="overflow-x-auto rounded-xl border border-slate-800">
        <Table>
          <TableHeader>
            <TableRow className="border-slate-800 hover:bg-transparent">
              <TableHead className="text-slate-400">Material</TableHead>
              <TableHead className="text-slate-400 text-right">Quantity</TableHead>
              <TableHead className="text-slate-400 text-right hidden sm:table-cell">Rate</TableHead>
              <TableHead className="text-slate-400 text-right">Est. Cost</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {result.materials.map((m) => (
              <TableRow key={m.key} className="border-slate-800" data-testid={`material-${m.key}`}>
                <TableCell className="font-medium text-white">{m.label}</TableCell>
                <TableCell className="text-right font-mono-data text-orange-300">
                  {num(m.quantity)} <span className="text-slate-500 text-xs">{m.unit}</span>
                </TableCell>
                <TableCell className="text-right font-mono-data text-slate-400 hidden sm:table-cell">
                  ₹{m.rate}
                </TableCell>
                <TableCell className="text-right font-mono-data text-white font-semibold">
                  ₹{inr(m.cost)}
                </TableCell>
              </TableRow>
            ))}
            <TableRow className="border-slate-800 bg-slate-950/60 hover:bg-slate-950/60">
              <TableCell colSpan={3} className="font-bold text-white">
                Total Material Cost
              </TableCell>
              <TableCell
                className="text-right font-mono-data font-extrabold text-orange-400"
                data-testid="material-total"
              >
                ₹{inr(result.material_cost_total)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <p className="text-xs text-slate-500 mt-3">
        * Quantities based on standard Indian thumb rules (IS Code / CPWD). Actual usage may vary
        ±10% by design & site conditions.
      </p>
    </Card>
  );
};
